import { motion } from 'framer-motion';
const transition = { duration: 0.8 };

const variants = {
  initial: { opacity: 0 },
  in: { opacity: 1 },
};

const PageTransition = ({ children }) => (
    <motion.div
        variants={variants}
        initial="initial" 
        animate="in" 
        transition={transition}
    >
        {children}
    </motion.div>
);

export default PageTransition;